/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as Char123LocaleChar125RouteRouteImport } from './routes/{-$locale}/route'
import { Route as Char123LocaleChar125HelpIndexRouteImport } from './routes/{-$locale}/help/index'
import { Route as Char123LocaleChar125IndexRouteImport } from './routes/{-$locale}/index'
import { Route as DotDotMosaicModulesOffersFlowsOfferDetailsOfferDetailsPageRouteImport } from './mosaic-modules/Offers/flows/offerDetails/OfferDetailsPage'

const Char123LocaleChar125RouteRoute =
  Char123LocaleChar125RouteRouteImport.update({
    id: '/{-$locale}',
    path: '/{-$locale}',
    getParentRoute: () => rootRouteImport,
  } as any)
const Char123LocaleChar125HelpIndexRoute =
  Char123LocaleChar125HelpIndexRouteImport.update({
    id: '/help',
    path: '/help',
    getParentRoute: () => Char123LocaleChar125RouteRoute,
  } as any)
const Char123LocaleChar125IndexRoute =
  Char123LocaleChar125IndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => Char123LocaleChar125RouteRoute,
  } as any)
const DotDotMosaicModulesOffersFlowsOfferDetailsOfferDetailsPageRoute =
  DotDotMosaicModulesOffersFlowsOfferDetailsOfferDetailsPageRouteImport.update({
    id: '/offer',
    path: '/offer',
    getParentRoute: () => Char123LocaleChar125RouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/{-$locale}': typeof Char123LocaleChar125RouteRouteWithChildren
  '/{-$locale}/offer': typeof DotDotMosaicModulesOffersFlowsOfferDetailsOfferDetailsPageRoute
  '/{-$locale}/': typeof Char123LocaleChar125IndexRoute
  '/{-$locale}/help': typeof Char123LocaleChar125HelpIndexRoute
}
export interface FileRoutesByTo {
  '/{-$locale}/offer': typeof DotDotMosaicModulesOffersFlowsOfferDetailsOfferDetailsPageRoute
  '/{-$locale}': typeof Char123LocaleChar125IndexRoute
  '/{-$locale}/help': typeof Char123LocaleChar125HelpIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/{-$locale}': typeof Char123LocaleChar125RouteRouteWithChildren
  '/{-$locale}/offer': typeof DotDotMosaicModulesOffersFlowsOfferDetailsOfferDetailsPageRoute
  '/{-$locale}/': typeof Char123LocaleChar125IndexRoute
  '/{-$locale}/help': typeof Char123LocaleChar125HelpIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/{-$locale}'
    | '/{-$locale}/offer'
    | '/{-$locale}/'
    | '/{-$locale}/help'
  fileRoutesByTo: FileRoutesByTo
  to: '/{-$locale}/offer' | '/{-$locale}' | '/{-$locale}/help'
  id:
    | '__root__'
    | '/{-$locale}'
    | '/{-$locale}/offer'
    | '/{-$locale}/'
    | '/{-$locale}/help'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  Char123LocaleChar125RouteRoute: typeof Char123LocaleChar125RouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/{-$locale}': {
      id: '/{-$locale}'
      path: '/{-$locale}'
      fullPath: '/{-$locale}'
      preLoaderRoute: typeof Char123LocaleChar125RouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/{-$locale}/help': {
      id: '/{-$locale}/help'
      path: '/help'
      fullPath: '/{-$locale}/help'
      preLoaderRoute: typeof Char123LocaleChar125HelpIndexRouteImport
      parentRoute: typeof Char123LocaleChar125RouteRoute
    }
    '/{-$locale}/': {
      id: '/{-$locale}/'
      path: '/'
      fullPath: '/{-$locale}/'
      preLoaderRoute: typeof Char123LocaleChar125IndexRouteImport
      parentRoute: typeof Char123LocaleChar125RouteRoute
    }
    '/{-$locale}/offer': {
      id: '/{-$locale}/offer'
      path: '/offer'
      fullPath: '/{-$locale}/offer'
      preLoaderRoute: typeof DotDotMosaicModulesOffersFlowsOfferDetailsOfferDetailsPageRouteImport
      parentRoute: typeof Char123LocaleChar125RouteRoute
    }
  }
}

interface Char123LocaleChar125RouteRouteChildren {
  DotDotMosaicModulesOffersFlowsOfferDetailsOfferDetailsPageRoute: typeof DotDotMosaicModulesOffersFlowsOfferDetailsOfferDetailsPageRoute
  Char123LocaleChar125IndexRoute: typeof Char123LocaleChar125IndexRoute
  Char123LocaleChar125HelpIndexRoute: typeof Char123LocaleChar125HelpIndexRoute
}

const Char123LocaleChar125RouteRouteChildren: Char123LocaleChar125RouteRouteChildren =
  {
    DotDotMosaicModulesOffersFlowsOfferDetailsOfferDetailsPageRoute:
      DotDotMosaicModulesOffersFlowsOfferDetailsOfferDetailsPageRoute,
    Char123LocaleChar125IndexRoute: Char123LocaleChar125IndexRoute,
    Char123LocaleChar125HelpIndexRoute: Char123LocaleChar125HelpIndexRoute,
  }

const Char123LocaleChar125RouteRouteWithChildren =
  Char123LocaleChar125RouteRoute._addFileChildren(
    Char123LocaleChar125RouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  Char123LocaleChar125RouteRoute: Char123LocaleChar125RouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
